export const formItem = [
    {
        label: 'Độ nhạy',
        type: 'slider',
        name: 'sensitive',
        span: 24
    }
]